export function handleRadioStringChange(handler: (value: string) => void) {
    return (event: React.FormEvent<HTMLElement>) =>
        handler((event.target as HTMLInputElement).value);
}
